<app-admin-navbar></app-admin-navbar>

<div class="page">

  <div class="card">

    <h1>
      Add Category
    </h1>

    <div class="form-group">

      <label>
        Category Name
      </label>

      <input
        type="text"

        [(ngModel)]="
          category.name
        "

        (input)="
          onNameChange()
        ">

    </div>

    <div class="form-group">

      <label>
        Slug
      </label>

      <input
        type="text"

        [(ngModel)]="
          category.slug
        ">

    </div>

    <div class="form-group">

      <label>
        Category Image
      </label>

      <input
        type="file"

        accept="image/*"

        (change)="
          onFileSelected($event)
        ">

    </div>

    <div
      class="image-preview"

      *ngIf="
        imagePreview
      ">

      <img
        [src]="imagePreview"

        alt="Preview">

    </div>

    <div
      class="upload-status"

      *ngIf="
        uploading
      ">

      Uploading image...

    </div>

    <button
      class="btn-save"

      [disabled]="
        saving ||
        uploading
      "

      (click)="save()">

      {{

        uploading
          ? 'Uploading Image...'

          : saving
            ? 'Saving...'

            : 'Save Category'

      }}

    </button>

  </div>

</div>